<script>
  import { onMount } from 'svelte'
  import Accordion2 from './Accordion2.svelte'
  import { bestofs, fetchFullBestof, lang } from './../store.js'

  onMount(fetchFullBestof)

  const i18n = {
    title: {
      en: 'From the ranking of the #datetime#',
      fr: 'Données issues du classement du #datetime#',
    },
    legend: {
      en: '🐣 = first timer - ✔️ = foil ',
      fr: '🐣 = bizuth - ✔️ = foil ',
    },

    last_hour: {
      en: 'over the last 30 minutes of the last ranking',
      fr: 'sur les 30 dernières minutes du dernier relevé',
    },
    last_report: {
      en: 'since the last ranking',
      fr: 'depuis le classement précédent',
    },
    last_24h: {
      en: 'over the last 24h',
      fr: 'sur les dernières 24 heures',
    },

    avg_speed: {
      en: 'The fastest',
      fr: 'Le/la plus rapide',
    },
    avg_vmg: {
      en: 'Best average VMG',
      fr: 'Meilleure VMG moyenne',
    },
    highest_speed_progress: {
      en: 'Highest average speed progress',
      fr: 'Plus forte augmentation de la vitesse moyenne',
    },
    lowest_speed_progress: {
      en: 'Lowest average speed progress',
      fr: 'Plus forte baisse de la vitesse moyenne',
    },
    highest_gap_progress: {
      en: 'Highest gap gain over the leader',
      fr: 'Plus fort rapprochement au leader',
    },
    lowest_gap_progress: {
      en: 'Lowest gap gain over the leader',
      fr: 'Plus fort éloignement au leader',
    },
    distance: {
      en: 'Largest distance',
      fr: 'Plus grande distance parcourue',
    },
  }

  const reportsConfig = {
    // one hour
    one_hour_speed: {
      unit: 'kn',
      headerClass: 'odd',
      title_1: `${i18n.avg_speed[$lang]}`,
      title_2: `${i18n.last_hour[$lang]}`,
    },
    one_hour_vmg: {
      unit: 'kn',
      headerClass: 'even',
      title_1: `${i18n.avg_vmg[$lang]}`,
      title_2: `${i18n.last_hour[$lang]}`,
    },

    // last report
    last_report_speed: {
      unit: 'kn',
      headerClass: 'odd',
      title_1: `${i18n.avg_speed[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },
    last_report_vmg: {
      unit: 'kn',
      headerClass: 'even',
      title_1: `${i18n.avg_vmg[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },
    last_report_distance: {
      unit: 'nm',
      headerClass: 'odd',
      title_1: `${i18n.distance[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },
    last_report_speed_highs: {
      unit: '%',
      headerClass: 'even',
      title_1: `${i18n.highest_speed_progress[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },
    last_report_speed_lows: {
      unit: '%',
      headerClass: 'odd',
      title_1: `${i18n.lowest_speed_progress[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },
    last_report_gap_to_leader_highs: {
      unit: 'nm',
      headerClass: 'even',
      title_1: `${i18n.highest_gap_progress[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },
    last_report_gap_to_leader_lows: {
      unit: 'nm',
      headerClass: 'odd',
      title_1: `${i18n.lowest_gap_progress[$lang]}`,
      title_2: `${i18n.last_report[$lang]}`,
    },

    // last 24h
    last_day_speed: {
      unit: 'kn',
      headerClass: 'odd',
      title_1: `${i18n.avg_speed[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
    last_day_vmg: {
      unit: 'kn',
      headerClass: 'even',
      title_1: `${i18n.avg_vmg[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
    last_day_distance: {
      unit: 'nm',
      headerClass: 'odd',
      title_1: `${i18n.distance[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
    last_day_speed_highs: {
      unit: '%',
      headerClass: 'even',
      title_1: `${i18n.highest_speed_progress[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
    last_day_speed_lows: {
      unit: '%',
      headerClass: 'odd',
      title_1: `${i18n.lowest_speed_progress[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
    last_day_gap_to_leader_highs: {
      unit: 'nm',
      headerClass: 'even',
      title_1: `${i18n.highest_gap_progress[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
    last_day_gap_to_leader_lows: {
      unit: 'nm',
      headerClass: 'odd',
      title_1: `${i18n.lowest_gap_progress[$lang]}`,
      title_2: `${i18n.last_24h[$lang]}`,
    },
  }

  let datetime = ''
  let lastReportSpeedLows
  let lastReportGapToLeaderLows
  let lastDaySpeedLows
  let lastDayGapToLeaderLows
  const unsubscribe = bestofs.subscribe((value) => {
    if (value == undefined || value.length == 0) {
      return
    }
    lastReportSpeedLows = [...value.last_report_speed_highs].reverse()
    lastReportGapToLeaderLows = [
      ...value.last_report_gap_to_leader_highs,
    ].reverse()
    lastDaySpeedLows = [...value.last_day_speed_highs].reverse()
    lastDayGapToLeaderLows = [...value.last_day_gap_to_leader_highs].reverse()

    const dt = new Date(value.one_hour_speed[0].date)
    datetime = `${dt.toLocaleDateString($lang)} ${dt
      .toLocaleTimeString($lang)
      .slice(0, -3)}`
  })
</script>

<style>
  * {
    margin: 0;
    padding: 0;
    font-family: 'Lato', sans-serif;
    list-style: none;
    text-decoration: none;
  }
  main {
    display: grid;
  }
  /* @media (min-width: 700px) {
      main {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        grid-template-areas:
          '. .'
          '. .'
          '. .';
      }
    } */
  @media (min-width: 1030px) {
    main {
      /* grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr 1fr 1fr; */
      column-gap: 1em;
      grid-template-areas:
        '. . .'
        '. . .'
        '. . .'
        '. . .';
    }
  }
  h2 {
    font-family: Montserrat, sans-serif;
    text-align: center;
  }
  h3,
  h5 {
    text-align: center;
  }
</style>

{#await $bestofs}
  <h1>loading</h1>
{:then data}
  <h2>{i18n.title[$lang].replace('#datetime#', datetime)}</h2>
  <h5>{i18n.legend[$lang]}</h5>
  <main>
    <div>
      <Accordion2
        data={data.one_hour_speed}
        {...reportsConfig.one_hour_speed} />
      <Accordion2 data={data.one_hour_vmg} {...reportsConfig.one_hour_vmg} />
    </div>
    <div>
      <Accordion2
        data={data.last_report_speed}
        {...reportsConfig.last_report_speed} />
      <Accordion2
        data={data.last_report_vmg}
        {...reportsConfig.last_report_vmg} />
      <Accordion2
        data={data.last_report_distance}
        {...reportsConfig.last_report_distance} />
      <Accordion2
        data={data.last_report_speed_highs}
        {...reportsConfig.last_report_speed_highs} />
      <Accordion2
        data={lastReportSpeedLows}
        {...reportsConfig.last_report_speed_lows} />
      <Accordion2
        data={data.last_report_gap_to_leader_highs}
        {...reportsConfig.last_report_gap_to_leader_highs} />
      <Accordion2
        data={lastReportGapToLeaderLows}
        {...reportsConfig.last_report_gap_to_leader_lows} />
    </div>
    <div>
      <Accordion2
        data={data.last_day_speed}
        {...reportsConfig.last_day_speed} />
      <Accordion2 data={data.last_day_vmg} {...reportsConfig.last_day_vmg} />
      <Accordion2
        data={data.last_day_distance}
        {...reportsConfig.last_day_distance} />
      <Accordion2
        data={data.last_day_speed_highs}
        {...reportsConfig.last_day_speed_highs} />
      <Accordion2
        data={lastDaySpeedLows}
        {...reportsConfig.last_day_speed_lows} />
      <Accordion2
        data={data.last_day_gap_to_leader_highs}
        {...reportsConfig.last_day_gap_to_leader_highs} />
      <Accordion2
        data={lastDayGapToLeaderLows}
        {...reportsConfig.last_day_gap_to_leader_lows} />
    </div>
  </main>
{/await}
<!-- <footer class="main-footer">by regadata 2020</footer> -->
